const url = "https://api.codestrup.in";
// const url = "http://192.168.1.132:8080";
// const url = "http://192.168.215.67:8080";

const ApiConfig = {
  login: `${url}/users/login`,
  updatePassword: `${url}/users/updatePassword`,
  applicationData: `${url}/users/applicationData`,
  getAchievement: `${url}/users/getAchievementsData`,
  getUserProfile: `${url}/users/getUserProfile`,
  submitTask: `${url}/users/submitTask`,
  taskStatus: `${url}/users/showUserTask`,
  getLastSubmittedTask: `${url}/users/getLastSubmittedTask`,
  getGemResult: `${url}/gemini/getGemResult`,
  getLinkJobs: `${url}/getLinkJobs`,
  courses: `${url}/api/courses`,
  generate: `${url}/api/generate`,
  image: `${url}/api/image`,
  update: `${url}/api/update`,

  getInterviewQuetion: `${url}/api/getInterviewQuetion`,
  updateinterviewQuetion: `${url}/api/updateinterviewQuetion`,

  getAptitude: `${url}/api/getAptitude`,
  generatePrompt: `${url}/api/generatePrompt`,
  aptitudeImage: `${url}/api/createImage`,
  updateAptitude: `${url}/api/updateAptitude`,

  //Notice
  getAllNotices: `${url}/api/getAllNotices`,
  notice: `${url}/api/notice`,

  forgotPassword: `${url}/forgot-password`,
  resetPassword: `${url}/reset-password`,
  getAllNotifications: `${url}/getAllNotifications`,
  readNotification: `${url}/readNotification`,
  verifyOto: `${url}/verify-otp`,

  //offer Letter
  sendOfferLetter: `${url}/sendOfferLetter`,

  //certificate
  getCertificate: `${url}/getCertificate`,
  createCertificate: `${url}/createCertificate`,
  downloadCertificate: `${url}/downloadCertificate`,

  // referrals
  referralWallet: `${url}/referral-wallet`,
  addAccountDetails: `${url}/addAccount-details`,
  getAccDetailById: `${url}/getAccDetailById`,
  updateAccountDetails: `${url}/updateAccountDetails`,
  createWithdrawRequest: `${url}/createWithdrawRequest`,
  withdrawals: `${url}/withdrawals`,

  //Videos
  getCourseVideos: `${url}/api/getCourseVideos`,
  updateProfilePic: `${url}/users/updateUserProfile`,

  //letter of internship
  uploadInternshipLetter: `${url}/uploadInternshipLetter`,
  getInternshipLetter: `${url}/getInternshipLetter`,
  getAppSetting: `${url}/getAppSetting`,

  //user modules
  getFreeModules: `${url}/getFreeModules`,
  upgradeInternship: `${url}/upgrade-internship`,

  //video course

  createCourseCertificate: `${url}/createCourseCertificate`,
  getCourseCertificate: `${url}/getCourseCertificate`,
  downloadCourseCertificate: `${url}/downloadCourseCertificate`,

  //image urls
  getImageUrl: `${url}/getImageUrl`,
};
export default ApiConfig;
